<template>
  <div
    :class="headerClasses"
    :style="headerStyles"
    class="q-px-xs text-bold"
  >
    <span
      v-if="header.label"
      style="min-width: 30px;"
      v-html="header.label"
    />
    <q-icon
      v-if="currentSort && currentSort.sortBy === header.key && header.sortable"
      :name="currentSort.sortDirection === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down'"
      :class="{'q-ml-xs': !!header.label}"
      size="1rem"
    />
  </div>
</template>

<script>
import cellMixin from './cellMixin'
import { strToObj } from 'src/helpers/globals'

export default {
  mixins: [cellMixin],
  props: {
    currentSort: {
      type: Object,
      default: null
    }
  },
  computed: {
    headerClasses () {
      return strToObj(this.classes, {
        'cursor-pointer': this.header.sortable || false
      })
    },
    headerStyles () {
      return strToObj(this.styles, {
        'min-height': this.header.sortable ? '15px' : undefined
      })
    }
  }
}
</script>
